module.exports = __webpack_public_path__ + "a59613ca4cd00c0e65dce43eedb1427f.svg";